module.exports = "/static/img/messenger_icon.svg?469bcdf55de615e8fef2df2abdf97f78";